module.exports = __webpack_public_path__ + "static/card12-b81da5e7654a135e03671ba691205e36.png";